import { Base64 } from 'dg-web-shared/common/utils/Base64.ts';
import { extractScannedUrlPathValue } from './ScannedUrlNormalization.ts';

const PARKINGPAY_TICKET_PATH = '/t/';
const PARKINGPAY_QR_TICKET_PATH = '/qrt/';
const TICKET_BASE_256_LENGTH = 12;
const QR_TICKET_ID_LENGTH = 36;
const TICKET_BASE_256_PATTERN = /^[A-Za-z0-9+/=_-]*$/;
const QR_TICKET_DISPLAY_LENGTH = 8;

export function normalizeTicketSearchInput(value: string) {
    return normalizeTicketPlus(normalizeQrTicket(value));
}

function normalizeTicketPlus(value: string) {
    const ticketString = extractScannedUrlPathValue(
        value,
        PARKINGPAY_TICKET_PATH,
    );
    if (
        !ticketString ||
        ticketString.length !== TICKET_BASE_256_LENGTH ||
        !TICKET_BASE_256_PATTERN.test(ticketString)
    ) {
        return value;
    }

    return parseTicketBase64(ticketString);
}

function normalizeQrTicket(value: string) {
    const ticketId = extractScannedUrlPathValue(
        value,
        PARKINGPAY_QR_TICKET_PATH,
    );
    if (!ticketId || ticketId.length !== QR_TICKET_ID_LENGTH) {
        return value;
    }
    return ticketId.slice(0, QR_TICKET_DISPLAY_LENGTH);
}

function parseTicketBase64(value: string) {
    try {
        const binaryString = Base64.decodeURLSafe(value);
        const facility =
            binaryString.charCodeAt(0) * 256 + binaryString.charCodeAt(1);
        const facilityString = facility.toString().padStart(4, '0');
        const type =
            binaryString.charCodeAt(2) * 256 + binaryString.charCodeAt(3);
        const typeString = type.toString().padStart(2, '0');
        const ticket =
            binaryString.charCodeAt(4) * 256 + binaryString.charCodeAt(5);
        const ticketString = ticket.toString().padStart(4, '0');
        const role =
            binaryString.charCodeAt(6) * 256 + binaryString.charCodeAt(7);
        const roleString = role.toString().padStart(4, '0');
        return `${facilityString}.${ticketString}.${roleString}.${typeString}`;
    } catch (e) {
        console.error('Failed to parse ticket string:', value, e);
        return value;
    }
}
